import { MeasureDateRange } from "../../../../../api/types/fieldConfigurationTypes.ts";

export const ranges = [
  { value: MeasureDateRange.BeginningBalance, text: "Beginning Balance", short: "BB" },
  { value: MeasureDateRange.NetChange, text: "Net Change", short: "NC" },
  { value: MeasureDateRange.EndingBalance, text: "Ending Balance", short: "EB" },
  { value: MeasureDateRange.Mtd, text: "Month-to-date", short: "MTD" },
  { value: MeasureDateRange.Qtd, text: "Quarter-to-date", short: "QTD" },
  { value: MeasureDateRange.Ytd, text: "Year-to-date", short: "YTD" },
  { value: MeasureDateRange.Ltm, text: "Last 12 months", short: "LTM" },
];

export function dateRangeToShortString(range: MeasureDateRange | undefined | null) {
  const found = ranges.find((r) => r.value === range);
  return found?.short ?? "";
}
